import { useAiScheduleAccess } from '@frontend/ai-receptionist-settings';
import { useTranslation } from '@frontend/i18n';
import { useSettingsNavigate } from '@frontend/settings-routing';
import { BannerNotification, NakedButton, Text } from '@frontend/design-system';

export const ManageProvidersAvailabilityBanner = () => {
  const { t } = useTranslation('schedule-settings');
  const { navigate } = useSettingsNavigate();

  const { airCohort, canEditBridgelineScheduleSettings } = useAiScheduleAccess();

  const shouldHideBanner = airCohort === 'bridgeline' && !canEditBridgelineScheduleSettings;

  if (shouldHideBanner) {
    return null;
  }

  return (
    <BannerNotification
      status='info'
      fullWidth
      css={{ marginBottom: 'var(--fabric-space-gap-md)' }}
      message={
        <Text size='medium' css={{ margin: 0 }}>
          {t('Updates to this page do not affect provider availability or online scheduling.')}
          <NakedButton
            onClick={() => navigate({ to: '/schedule/availability' })}
            css={{
              color: 'var(--fabric-color-accent-blue-base)',
              textDecoration: 'underline',
              marginLeft: 'var(--fabric-space-gap-xxs)',
            }}
          >
            {t('Update availability settings')}
          </NakedButton>
        </Text>
      }
    />
  );
};
